module.exports = __webpack_public_path__ + "img/38_4.cd44db5b.png";